import type { AxiosResponse } from "axios";
import { get } from "../../../hook/request";
import type { CategoryApiItem, CategoryParentApiResponse } from "./types";

export async function getCategoriesByParent(parentID: number = 0): Promise<CategoryApiItem[]> {
  const res: AxiosResponse<CategoryParentApiResponse> = await get(
    `/categories/parent?ID=${encodeURIComponent(String(parentID))}`
  );

  const payload = res.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

